<template>
  <div class="controller">
    <ul class="action_buttons">
      <li class="forced_logout_li">
        <input
          v-if="selectedCareworkerList.length == 0"
          type="button"
          :value="forcedLogout"
          class="forced_logout_button disabled"
        />
        <input
          v-if="selectedCareworkerList.length != 0"
          type="button"
          :value="forcedLogout"
          class="forced_logout_button"
          @click="showConfirmModal = true"
        />
      </li>
      <li class="lastUpdate_label">
        {{ lastUpdate }}
        {{ lastUpdateDateTime }}
      </li>
      <li class="update_li">
        <input
          type="button"
          :value="search"
          class="search_login_user_button"
          @click="$emit('input-event')"
        />
      </li>
    </ul>
    <div class="false_modal_window" v-if="showFalseModal">
      <completeModalWindow :question="falseWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="false_modal_window" v-if="showCompleteModal">
      <completeModalWindow :question="completeWord" @close="closeComplete">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="modal_window" v-if="showConfirmModal">
      <confirmCustomTitleModalWindow
        :title="confirmModalTitle"
        :question="confirmModalQuestion"
        @close="close"
        @ok="logoutUser"
      >
      </confirmCustomTitleModalWindow>
    </div>
  </div>
</template>

<script>
import completeModalWindow from './modalWindow/finishModalWindow.vue'
import loadingModalWindow from './modalWindow/loadingModalWindow.vue'
import confirmCustomTitleModalWindow from './modalWindow/confirmCustomTitleModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      lastUpdate: '取得時間 : ',
      search: '検索',
      forcedLogout: '強制ログアウト',
      confirmModalTitle: '強制ログアウト',
      confirmModalQuestion:
        '選択したユーザを強制ログアウトします。<br/>よろしいですか？',
      showFalseModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      windowHeight: '',
      isOpen: [],
      inputValue: '',
      falseWord: '',
      completeWord: '',
      showConfirmModal: false,
      // 更新ボタン連打防止フラグ
      updateActionFlag: false
    }
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    lastUpdateDateTime() {
      return this.$store.state.loginUsers.lastUpdateDateTime
    },
    selectedCareworkerList() {
      return this.$store.state.loginUsers.selectedLoginUsersList
    }
  },
  async created() {
    let strHours = '00' + new Date().getHours()
    let strMinutes = '00' + new Date().getMinutes()
    let lastUpdateDateTime =
      new Date().toLocaleDateString() +
      ' ' +
      strHours.substr(-2) +
      ':' +
      strMinutes.substr(-2)
    this.$store.dispatch('loginUsers/setLastUpdateDateTime', lastUpdateDateTime)
  },
  components: {
    completeModalWindow,
    loadingModalWindow,
    confirmCustomTitleModalWindow
  },
  methods: {
    close(e) {
      this.showConfirmModal = false
      this.showFalseModal = false
      this.showCompleteModal = false
    },
    closeComplete(e) {
      this.showConfirmModal = false
      this.showFalseModal = false
      this.showCompleteModal = false
      this.$emit('reload')
    },
    async logoutUser(e) {
      this.showConfirmModal = false
      this.showloadingModal = true
      let logoutIdList = []
      for (let i = 0; i < this.selectedCareworkerList.length; i++) {
        if (this.selectedCareworkerList[i].checked === true) {
          let userId = this.selectedCareworkerList[i].userId
          logoutIdList.push({userId: userId})
        }
      }
      try {
        await this.$store.dispatch('loginUsers/loginUserLogout', logoutIdList)
        this.completeWord = '対象のユーザをログアウトしました。'
        this.showCompleteModal = true
        this.$store.dispatch('loginUsers/clearSelectedLoginUsersList')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_600003
        let eventType = 3
        let reason = 'MSGCRC0205 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0205.name +
            this.errorMsg.MSGCRC0205.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.controller {
  width: 480px;
  margin-left: auto;
  margin-right: 0;
}
.action_buttons {
  width: 480px;
}
.lastUpdate_label {
  display: inline-block;
  table-layout: fixed;
  color: #00b0a8;
  vertical-align: middle;
  margin-right: 3%;
}
.update_li {
  display: inline-block;
}
.search_login_user_button {
  width: 85px;
  height: 40px;
  color: #fff;
  border-radius: 3px;
  margin: 0 8px 0 0;
  border: none;
  background-color: #00afa8;
}
.forced_logout_li {
  display: inline-block;
}
.forced_logout_button {
  width: 105px;
  height: 40px;
  color: #fff;
  border-radius: 3px;
  margin: 0 8px 0 0;
  border: none;
  background-color: #00afa8;
}
.disabled {
  background-color: #afafaf;
}
</style>



// WEBPACK FOOTER //
// src/components/controllerLoginUser.vue